import React from "react";
import { motion } from "framer-motion";
import { Search, FileCheck2, Truck, Sparkles } from "lucide-react";

const STEPS = [
  { n: "01", icon: Search, title: "Explora sin fricción", body: "Filtra por marca, versión y presupuesto. Compara especificaciones y precios en segundos, desde tu celular." },
  { n: "02", icon: FileCheck2, title: "Aprobación en 24 hrs", body: "Cotiza y solicita crédito 100% digital. Aprobación máxima en 24 horas hábiles, incluso a clientes con historial complicado." },
  { n: "03", icon: Truck, title: "Entrega a domicilio", body: "Recibe tu auto donde tú decidas. Y aquí lo mejor: pagas el enganche solo cuando lo tengas frente a ti." },
  { n: "04", icon: Sparkles, title: "Sin sorpresas", body: "Estrena con garantía de agencia, factura original y financiamiento con la mejor tasa para tu caso." },
];

export default function HowItWorks() {
  return (
    <section
      id="como-funciona"
      className="relative bg-[#FFFFFF] text-[#0B1623] py-20 md:py-28"
      data-testid="how-it-works"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-14 md:mb-20">
          <span className="font-rajdhani font-medium text-[#3B82F6] text-xs md:text-sm tracking-[0.4em] uppercase">
            Proceso HEBEH
          </span>
          <h2 className="font-rajdhani font-semibold text-[#0B1623] tracking-tight leading-[0.95] text-3xl sm:text-4xl md:text-5xl mt-4">
            Cuatro pasos.
            <br />
            Cero fricción.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10">
          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.article
                key={s.n}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: i * 0.08 }}
                className="group relative overflow-hidden rounded-2xl border border-[#0B1623]/8 bg-white p-8 md:p-10 hover:shadow-[0_20px_50px_rgba(11,22,35,0.06)] transition-all duration-500"
                data-testid={`how-step-${i + 1}`}
              >
                <div className="absolute -top-24 -right-24 w-64 h-64 rounded-full bg-[#3B82F6]/40 opacity-0 group-hover:opacity-15 blur-3xl transition-opacity duration-700" />
                <div className="flex items-start gap-6">
                  <span className="font-rajdhani font-light text-[#0B1623]/12 text-6xl md:text-7xl leading-none select-none">
                    {s.n}
                  </span>
                  <div className="flex-1">
                    <div className="inline-flex items-center justify-center w-11 h-11 rounded-full bg-[#3B82F6]/12 text-[#3B82F6] mb-5">
                      <Icon className="w-5 h-5" />
                    </div>
                    <h3 className="font-rajdhani font-semibold text-[#0B1623] text-xl md:text-2xl tracking-tight leading-tight">
                      {s.title}
                    </h3>
                    <p className="font-manrope text-[#0B1623]/65 mt-3 leading-relaxed">{s.body}</p>
                  </div>
                </div>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
